import React, { useState, useEffect } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  MenuItem,
  Dialog
} from '@mui/material'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { HashLink as Link } from 'react-router-hash-link'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import toast from 'react-simple-toasts'
import { NumericFormat } from 'react-number-format'
import Paragraph from '../../components/Typography/Paragraph'
import FormInput from '../../components/FormInput/FormInput'
import Button from '../../components/Button/Button'
import CloseIcon from '@mui/icons-material/Close'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Loader from 'react-js-loader'
import useStyles from './styles'
import './styles.css'
import Logo from '../../assets/images/Header Logo.png'
import premiumicon from '../../assets/images/premiumicon.svg'
import BackIcon from '../../assets/images/Arrow Left.svg'
import HeaderIcon from '../../assets/images/HeaderIcon.svg'
import CopyIcon from '../../assets/images/Copy.svg'
import MenuIcon from '../../assets/images/Menu.svg'
import UserIcon from '../../assets/images/User.svg'
import ArrowDown from '../../assets/images/Arrow Down.svg'
import ArrowUp from '../../assets/images/ArrowUp.svg'
import WhatsappIcon from '../../assets/images/whatsapp.png'
// import HeaderSettingIcon from "../../assets/images/Header Setting Icon.svg"
// import HeaderLogoutIcon from "../../assets/images/Header Logout Icon.svg"
import { get_user_info } from '../../api/API'
import useUser from '../../hooks/useUser'
import useLocales from '../../hooks/useLocales'

const drawerWidth = '80%'
const navItems = ['Home', 'About', 'Contact']

export default function Header (props) {
  const classes = useStyles()
  const location = useLocation()
  const navigate = useNavigate()
  const { set_user, get_user } = useUser()
  const { allLang, currentLang, translate, onChangeLang } = useLocales()
  // console.log(get_user())
  // console.log(location.pathname.replace(/[^A-Za-z]+/g, ''))

  const { windows } = props
  const [loading, setLoading] = useState(false)
  const [openPopup, setopenPopup] = useState(false)
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [userData, setUserData] = useState(null)
  const [opacityData, setOpacityData] = useState({
    opacity: 0,
    visibility: 'hidden'
  })

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }
  useEffect(() => {
    if (mobileOpen == false) {
      setTimeout(() => {
        setOpacityData({
          opacity: 0,
          visibility: 'hidden'
        })
      }, 250)
    } else {
      setOpacityData({
        opacity: 1,
        visibility: 'visible'
      })
    }
  }, [mobileOpen])
  const [userAccordian, setUserAccordian] = React.useState(true)

  const handleLogout = () => {
    set_user(null)
    window.localStorage.removeItem('token')
    navigate('../')
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }

  const handleGetData = async () => {
    var ResToken = window.localStorage.getItem('token')

    var resData = await get_user_info({})
    if (resData.status) {
      setUserData(resData.data)
      set_user(resData.data)
    } else {
      setUserData(null)
      set_user(null)
      navigate('../')
      window.localStorage.removeItem('token')
      if (ResToken != null) {
        window.location.reload()
      }
    }
    // let resToken = window.localStorage.getItem('token')
    // let accept_res = window.localStorage.getItem('accept')
    // console.log(accept_res)
    // if (accept_res != null && accept_res == 'true') {
    //   setopenPopup(true)
    // }
  }

  const handleCheckIp = async () => {
    var formData = new FormData()
    var token = window.localStorage.getItem('token')
    formData.append('token', token == null ? 0 : token)
    setLoading(true)
    var resIP = await test_ip(formData)
    if (resIP) {
      console.log('cannot')
      navigate('../404')
    } else {
      console.log('can')

      // navigate('../')
    }
    // console.log(resIP)
    // if (resIP.status) {
    //   setLoading(false)
    // }
  }

  useEffect(() => {
    // handleCheckIp()
    AOS.init()
    handleGetData()
  }, [])

  const handleCustomer = async () => {
    // setLoading(true);
    var resLevel = await customer_services({})
    if (resLevel.status) {
      if (resLevel.data) {
        window.location.href = resLevel.data
        // window.Tawk_API.maximize()
      }
    } else {
      toast(resLevel.message)
    }
  }

  const handleChangeLanguage = e => {
    onChangeLang(e.target.value)
    if (e.target.value == 'en') {
      window.localStorage.setItem('language', 0)
      // moment.locale()
      // moment.updateLocale('en-gb', localizationen);
    } else {
      window.localStorage.setItem('language', 1)
      // moment.locale('zh-cn')
      // moment.updateLocale('zh-cn', localizationzh);
    }
    window.location.reload()
  }

  const handleCopyClick = async text => {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text)
        console.log('Text copied to clipboard')
        // toast(translate('Copy Successful')); // Uncomment if you want a toast message
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    } else {
      // Fallback for older browsers:
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        toast(translate('Copy Successful'))
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
      document.body.removeChild(textArea)
    }
  }

  const determineColor = score => {
    if (score >= 80 && score <= 100) {
      return '#12B887'
    } else if (score >= 60 && score <= 79) {
      return '#D7D702'
    } else {
      return '#E93F4F'
    }
  }

  return (
    <React.Fragment>
      <div className='customContainer'>
        <div className={classes.theSticky}>
          <div className='customContainer'>
            <div className={classes.theNavBar} data-aos='fade-up'>
              <div className={classes.theNavIcon}>
                <div className={classes.theIcon20} onClick={handleDrawerToggle}>
                  <img src={MenuIcon} alt={MenuIcon} />
                </div>
              </div>
              <div
                className={classes.theLogo}
                onClick={() => navigate('../home')}
              >
                <img src={Logo} />
              </div>
              {/* <div className={classes.theIcon20}>
                <img src={MenuIcon} alt={MenuIcon} />
              </div> */}
              <div className={classes.theLang}>
                <div className={classes.theField}>
                  <FormInput
                    name='password'
                    placeholder='Password'
                    value={currentLang.value}
                    onChange={handleChangeLanguage}
                    fontWeight='500'
                    textcolor='var(--accent-color)'
                    // border="1px solid var(--secondary-color)"
                    bg='var(--background-color-2)'
                    padding='6px'
                    paddingright='6px'
                    iconright='3px'
                    //   mb='15px'
                    size='12px'
                    iconsize='1.2rem'
                    borderradius='5px'
                    fontfamily='Montserrat, sans-serif'
                    select
                  >
                    <MenuItem value={'en'}>{translate('EN')}</MenuItem>
                    {/* <MenuItem value={'id'}>{translate('ID')}</MenuItem> */}
                  </FormInput>
                  {/* <div className={classes.theAbsoluteSearch}>
                  <div className={classes.theIcon20}>
                    <img src={SearchIcon} alt={SearchIcon} />
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.theSticky}>
          <div className='customContainer'>
            <div
              className={
                mobileOpen ? classes.customDrawerShow : classes.customDrawer
              }
              style={{
                opacity: opacityData.opacity,
                visibility: opacityData.visibility
              }}
              onClick={handleDrawerToggle}
            >
              <div className={classes.customDrawerContentRelative}>
                <div
                  className={
                    mobileOpen
                      ? classes.customDrawerContent
                      : classes.customDrawerContentHide
                  }
                  onClick={e => e.stopPropagation()}
                >
                  {/* <div
                    className={classes.theSideBack}
                    onClick={handleDrawerToggle}
                  >
                    <div className={classes.theIcon15}>
                      <img src={BackIcon} alt={BackIcon} />
                    </div>
                    <Paragraph
                      color='#202020'
                      bold='600'
                      margin='0 0 0 7px'
                      size='14px'
                      letterSpacing='0.01em'
                      lineHeight='16px'
                      textTransform='uppercase'
                    >
                      {translate('Back')}
                    </Paragraph>
                  </div> */}
                  <React.Fragment>
                    <div>
                      <div className={classes.theSideUser}>
                        <div className={classes.theSULogo}>
                          <img src={Logo} alt={Logo} />
                        </div>
                        <div className={classes.theSideUserFlex}>
                          <div className={classes.theSULeft}>
                            <div className={classes.theSUUser}>
                              <div className={classes.theSUUserFlex}>
                                {userData != null && userData.is_premium == 1 && (
                                  <div className={classes.theSUUFIcon}>
                                    <img src={premiumicon} alt={premiumicon} />
                                  </div>
                                )}
                                <div className={classes.theSUUFText}>
                                  <Paragraph
                                    color='var(--accent-color)'
                                    bold='700'
                                    margin='18px 0'
                                    size='14px'
                                    letterSpacing='0.14px'
                                    lineHeight='16px'
                                    textTransform='none'
                                  >
                                    {userData != null && userData.name}
                                  </Paragraph>
                                </div>
                              </div>
                              <div className={classes.theSUReferal}>
                                <div className={classes.theSURText}>
                                  <Paragraph
                                    color='var(--sub-title-color)'
                                    bold='600'
                                    size='12px'
                                    letterSpacing='0.12px'
                                    lineHeight='16px'
                                    textTransform='none'
                                  >
                                    {translate('Credit Score:')}
                                  </Paragraph>
                                </div>
                                <div className={classes.theSURBox}>
                                  <div className={classes.theSUValueText}>
                                    <Paragraph
                                      color={
                                        userData != null &&
                                        determineColor(get_user().credit_score)
                                      }
                                      bold='600'
                                      center
                                      // margin='0 7px 0 0'
                                      size='12px'
                                      letterSpacing='0.12px'
                                      lineHeight='16px'
                                      textTransform='none'
                                    >
                                      {userData != null && (
                                        <NumericFormat
                                          displayType='text'
                                          // value={'100'}
                                          value={get_user().credit_score}
                                          allowLeadingZeros
                                          thousandSeparator=','
                                        />
                                      )}
                                    </Paragraph>
                                  </div>
                                </div>
                              </div>
                              <div className={classes.theSUReferal}>
                                <div className={classes.theSURText}>
                                  <Paragraph
                                    color='var(--sub-title-color)'
                                    bold='600'
                                    size='12px'
                                    letterSpacing='0.12px'
                                    lineHeight='16px'
                                    textTransform='none'
                                  >
                                    {translate('Referral Code:')}
                                  </Paragraph>
                                </div>
                                <div
                                  className={classes.theSURBox}
                                  onClick={() => {
                                    handleCopyClick(
                                      userData != null && userData.referal_code
                                    )
                                    // toast(translate('Copy Successful'))
                                  }}
                                >
                                  <div className={classes.theSUReferalText}>
                                    <Paragraph
                                      color='var(--accent-color)'
                                      bold='600'
                                      center
                                      // margin='0 7px 0 0'
                                      size='12px'
                                      letterSpacing='0.12px'
                                      lineHeight='16px'
                                      textTransform='none'
                                    >
                                      {userData != null &&
                                        userData.referal_code}
                                    </Paragraph>
                                  </div>
                                  <div className={classes.theSUReferalIcon}>
                                    <img src={CopyIcon} alt={CopyIcon} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div
                            className={classes.theIcon10}
                            onClick={() => setUserAccordian(!userAccordian)}
                          >
                            <img
                              src={userAccordian ? ArrowUp : ArrowDown}
                              alt={userAccordian ? ArrowUp : ArrowDown}
                            />
                          </div> */}
                        </div>
                        <div className={classes.theSideBalance}>
                          <Paragraph
                            color='var(--primary-color)'
                            bold='500'
                            margin='0 0 2px'
                            size='10px'
                            letterSpacing='0.1px'
                            lineHeight='16px'
                            textTransform='capitalize'
                          >
                            {translate('Available Balance')}
                          </Paragraph>
                          <Paragraph
                            color='var(--primary-color)'
                            bold='700'
                            size='16px'
                            letterSpacing='0.01px'
                            lineHeight='16px'
                            textTransform='uppercase'
                          >
                            ID{' '}
                            {userData != null && (
                              <NumericFormat
                                displayType='text'
                                // value={'551000.00'}
                                value={userData.balance}
                                allowLeadingZeros
                                thousandSeparator=','
                              />
                            )}
                            {/* SGD {numberWithCommas(userData.balance)} */}
                          </Paragraph>
                        </div>
                      </div>

                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../home')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='33px 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Home')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../market')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Market')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../recharge')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Recharge')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../withdraw')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Withdrawal')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../withdraw-method')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Withdraw Method')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../order-history')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Order History')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../capital-flow')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Capital Flow')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => navigate('../statistics')}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Statistics')}
                        </Paragraph>
                      </div>
                      <div
                        className={classes.theNavLink}
                        onClick={() => handleLogout()}
                      >
                        <Paragraph
                          color='var(--accent-color)'
                          bold='500'
                          margin='0 30px 0'
                          size='16px'
                          lineHeight='16px'
                          textTransform='capitalize'
                        >
                          {translate('Logout')}
                        </Paragraph>
                      </div>
                    </div>
                  </React.Fragment>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className={classes.theStickyIcon} onClick={() => handleCustomer()}>
          <img src={WhatsappIcon} alt={WhatsappIcon} />
        </div> */}
      </div>
    </React.Fragment>
  )
}
